import { render, staticRenderFns } from "./CollectionListCard.vue?vue&type=template&id=55bd02ba&scoped=true&"
import script from "./CollectionListCard.vue?vue&type=script&lang=js&"
export * from "./CollectionListCard.vue?vue&type=script&lang=js&"
import style0 from "./CollectionListCard.vue?vue&type=style&index=0&id=55bd02ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd02ba",
  null
  
)

export default component.exports